<ng-container *transloco="let t; prefix: 'PremiseHazard'">
  <div>
    <div>
      <label class="msi-label">{{ t('label.contacts') }}</label>
    </div>
    @for (contact of ContactsToAdd; track contact; let contactIdx = $index) {
      <div>
        <div class="row-with-cancel-icon msi-margin-s">
          <div class="form-row">
            <div>
              <button type="button" pButton [text]="true" [rounded]="true" [ariaLabel]="t('Item.modal.removeContact.header')" (click)="removeContact(contactIdx)">
                <msi-icon name="ic_remove" [size]="14" class="delete-icon" />
              </button>
            </div>
            <div class="information-column">
              <div>
                <label class="msi-label">{{ t('label.contactName') }}</label>
              </div>
              <div class="msi-margin-left-s">
                {{ contact.name }}
              </div>
            </div>
          </div>
        </div>
        <div class="msi-margin-left-s msi-margin-bottom-s">
          @if (contact.devices) {
            <div class="msi-margin-left-s">
              {{ t('label.devices') }}
              <div class="flex-column">
                @if (!contact.devices) {
                  <div>
                    {{ t('Item.text.noDevices') }}
                  </div>
                }
                @for (device of contact.devices; track device; let deviceIdx = $index) {
                  <div class="flex-column">
                    <div class="row-with-cancel-icon msi-margin-top-s msi-margin-left-s">
                      <div>
                        <button
                          type="button"
                          pButton
                          [text]="true"
                          [rounded]="true"
                          [ariaLabel]="t('Item.modal.removeDevice.header')"
                          (click)="removeDeviceFromContact(contactIdx, deviceIdx)"
                        >
                          <msi-icon name="ic_remove" [size]="14" class="delete-icon" />
                        </button>
                      </div>
                      <div>{{ t('label.device') }} {{ deviceIdx + 1 }}</div>
                    </div>
                    <div class="msi-margin-left-s flex-container-row">
                      <div class="information-column">
                        <div>
                          <label class="msi-label">{{ t('label.deviceType') }}</label>
                        </div>
                        <div class="msi-margin-left-s">
                          {{ device.deviceType.toString() | titlecase }}
                        </div>
                      </div>
                      <div class="information-column msi-margin-left-m">
                        @if (!device.deviceType) {
                          <div>
                            <label class="msi-label">{{ t('label.deviceAddress') }}</label>
                          </div>
                        }
                        @if (
                          device.deviceType
                            .toString()
                            .localeCompare('email', undefined, { sensitivity: 'base', caseFirst: 'lower' }) === 0
                        ) {
                          <div>
                            <label class="msi-label">{{ 'Terms.emailAddress' | transloco }}</label>
                          </div>
                        }
                        @if (
                          device.deviceType &&
                          device.deviceType
                            .toString()
                            .localeCompare('email', undefined, { sensitivity: 'base', caseFirst: 'lower' }) !== 0
                        ) {
                          <div>
                            <label class="msi-label">{{ 'Terms.phoneNumber' | transloco }}</label>
                          </div>
                        }
                        <div class="msi-margin-left-s">
                          {{ device.address }}
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
    }
    <div>
      <div>
        <button type="button" pButton (click)="openContactModal()">
          <msi-icon name="ic_add" />{{ t('Item.button.addContact') }}
        </button>
      </div>
    </div>
  </div>
</ng-container>
